export const imagePrompts = {
  heroHome: {
    id: 'hero-home',
    label: 'Hero — Home',
    prompt:
      'Cinematic ultra-wide shot of a modern black Mi-8 transport helicopter flying over Cairo and the Giza Pyramids at golden hour dusk. The helicopter tows a massive vibrant orange-red (#ff4e50) advertising banner with bold white text "FLY HIGH BROTHERS" and Arabic script. City lights glow below, sky gradient from deep orange to purple to dark navy. Professional aerial photography, 8K, dramatic lighting, high contrast, premium advertising aesthetic.',
  },
  problemBg: {
    id: 'problem-bg',
    label: 'Problem Section BG',
    prompt:
      'Abstract dark moody background representing digital ad overload — blurred billboards, phone screens with ignored ads, muted desaturated tones. Dark charcoal (#0a0a0a) and navy (#162a40). Subtle noise texture, cinematic, no text.',
  },
  serviceAerial: {
    id: 'service-aerial',
    label: 'Aerial Advertising Card',
    prompt:
      'Dramatic low-angle ground shot looking up at a helicopter flying over a packed stadium at night, towing a large glowing orange-red banner. Stadium floodlights, energetic crowd atmosphere, cinematic sports advertising, high contrast, professional photography.',
  },
  serviceDigital: {
    id: 'service-digital',
    label: 'Marketing & Digital Card',
    prompt:
      'Professional high-tech command center at night. Person seen from behind at a sleek desk with three curved monitors displaying colorful marketing analytics, 3D data visualizations, and glowing charts. Cool blue (#00c8ff) and orange-red (#ff4e50) ambient neon lighting, cinematic corporate tech aesthetic.',
  },
  serviceProduction: {
    id: 'service-production',
    label: 'Media Production Card',
    prompt:
      'Behind-the-scenes professional film set in a dark studio. Cinema camera on stabilizer rig, crew with softboxes and production monitors, actor in spotlight. Moody cinematic lighting, creative energy, broadcast-quality production atmosphere.',
  },
  serviceWeb: {
    id: 'service-web',
    label: 'Web & App Development Card',
    prompt:
      'Close-up side profile of a software developer at a minimalist modern desk at night. Two large monitors with clean colorful code in dark IDE theme, mechanical keyboard with subtle RGB. Screen glow in blue and white, premium tech workspace aesthetic.',
  },
  heroAerial: {
    id: 'hero-aerial',
    label: 'Hero — Aerial Advertising',
    prompt:
      'Cinematic wide-angle shot of a large Mi-8 helicopter flying over Cairo skyline at sunset with Giza Pyramids in hazy horizon. Helicopter trails a massive long white advertising banner with Arabic text. Warm golden hour lighting, 8K professional color grading, premium aerial advertising photography.',
  },
  aerialBannerDragging: {
    id: 'aerial-banner-dragging',
    label: 'Banner Dragging Service',
    prompt:
      'Low angle shot looking up at a helicopter in flight against deep blue twilight sky, pulling a large rectangular white fabric banner (300m x 15m scale impression). Motion blur on rotors, sharp focus on banner texture, professional advertising photography, dramatic perspective.',
  },
  aerialGiftDropping: {
    id: 'aerial-gift-dropping',
    label: 'Gift Dropping Service',
    prompt:
      'Helicopter hovering above a large outdoor celebration crowd at dusk, branded gift packages descending on parachutes with orange ribbons. Festive atmosphere, Egyptian urban setting, cinematic activation photography, warm golden light.',
  },
  aerialEventFlyover: {
    id: 'aerial-event-flyover',
    label: 'Event Flyovers Service',
    prompt:
      'Nighttime aerial view of a massive outdoor music festival with bright stage lights and dense crowd. Dark helicopter silhouette with searchlight flying low over venue. Vibrant stage lighting, cinematic event atmosphere, high energy concert scene.',
  },
  aerialVipSightseeing: {
    id: 'aerial-vip-sightseeing',
    label: 'VIP Sightseeing Service',
    prompt:
      'Stylized premium digital map of Cairo and Giza Egypt from aerial perspective. Nile River, Pyramids, and city landmarks with subtle glowing cyan (#00c8ff) markers. Dark navy (#162a40) background, clean modern cartographic aesthetic, luxury tourism feel.',
  },
  heroDigital: {
    id: 'hero-digital',
    label: 'Hero — Digital Marketing',
    prompt:
      'Modern marketing war room with multiple screens showing social media dashboards, campaign performance metrics, and creative ad mockups. Dark premium office, orange and cyan accent lighting, professional digital agency aesthetic.',
  },
  heroProduction: {
    id: 'hero-production',
    label: 'Hero — Media Production',
    prompt:
      'Cinematic wide shot of professional film crew on location at dusk with helicopter visible in background. Cinema cameras, lighting rigs, dramatic sky. Premium broadcast production atmosphere, Egypt landscape.',
  },
  heroWeb: {
    id: 'hero-web',
    label: 'Hero — Web Development',
    prompt:
      'Sleek modern workspace showing premium website and mobile app UI designs on large displays. Dark theme interfaces with orange and cyan accents. Minimalist developer studio, high-end digital product design aesthetic.',
  },
  heroStory: {
    id: 'hero-story',
    label: 'Hero — Our Story',
    prompt:
      'Professional portrait-style scene of aviation executive in pilot uniform standing beside helicopter on tarmac at sunset. Cairo skyline in background, confident leadership aesthetic, warm cinematic lighting, premium corporate aviation photography.',
  },
  ceoPortrait: {
    id: 'ceo-portrait',
    label: 'CEO — Captain Ahmed Abo El Magd',
    prompt:
      'Professional executive portrait of Egyptian aviation CEO in his 50s, confident expression, business attire with aviation context. Helicopter and sky in soft-focus background. Premium corporate headshot, warm natural lighting, authoritative and approachable.',
  },
  partnerSpark: {
    id: 'partner-spark',
    label: 'Spark Partnership',
    prompt:
      'Large-format LED billboard and outdoor media installation in modern Egyptian urban setting at night. Bright dynamic display, ground-level media infrastructure. Premium OOH advertising aesthetic, city lights, partnership branding feel.',
  },
  campaignEid: {
    id: 'campaign-eid',
    label: 'Campaign — Eid Activation',
    prompt:
      'Helicopter flying over Cairo cityscape during Eid celebration with festive banners. Night lights, celebratory atmosphere, aerial advertising campaign, cinematic documentary style photography.',
  },
  campaignStadium: {
    id: 'campaign-stadium',
    label: 'Campaign — Stadium Banner',
    prompt:
      'Helicopter towing massive banner over 80,000-seat stadium during major sports event. Packed crowd, dramatic scale, aerial advertising at peak visibility, professional sports marketing photography.',
  },
  campaignNorthCoast: {
    id: 'campaign-north-coast',
    label: 'Campaign — Brand Launch North Coast',
    prompt:
      'Helicopter banner campaign over Egypt North Coast beach resort at golden hour. Turquoise Mediterranean, luxury beachfront developments, premium brand launch atmosphere, aerial advertising photography.',
  },
  campaignSightseeing: {
    id: 'campaign-sightseeing',
    label: 'Campaign — VIP Sightseeing Giza',
    prompt:
      'Aerial view from helicopter window of Giza Pyramids and Sphinx at sunrise. Premium VIP tourism experience, golden light on ancient monuments, luxury aerial tour photography.',
  },
};
